
class Translations {
  all = {}

  init(translations) {
    translations.forEach(t => {
      if(t.key) {
        if(this.all[t.key]) {
          console.warn("Error translations : 2 keys identical (" + t.key + ")")
        }
        this.all[t.key] = t

      }
    })
  }

  // on accède à cette function via store.t
  get(key, language) {
    if(!this.all[key]) {
      console.warn("translation non existant for", key)
      return null
    }

    if(this.all[key][language]) {
      // normal
      return this.all[key][language]
    }

    if (this.all[key]["en"]) {
      // return english si existe
      console.warn("translation non existant for", key, "in", language, "but exists in english")
      return this.all[key]["en"]
    }
    else {
      console.warn("translation non existant for", key, "in", language, "nor in english")
      return null
    }
  }



}

export default new Translations()